export default __webpack_public_path__ + "static/media/admin-bg3.fb9fed8f.jpg";